const sectionTitleStyle = {
  fontFamily: "var(--font-serif)",
  fontStyle: "italic",
  fontSize: "17px",
  color: "var(--color-ink)",
  margin: 0,
};

const bodyStyle = { fontSize: "15px", lineHeight: 1.7, color: "rgba(10,9,7,0.85)", margin: 0 };
const listStyle = { display: "flex", flexDirection: "column", gap: "10px", margin: 0, paddingLeft: "20px" };

function Section({ title, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <p style={sectionTitleStyle}>{title}</p>
      {children}
    </div>
  );
}

/**
 * Real, filed founding document (see konzepte/Gesellschaftsvertrag_TalesLegends.docx)
 * — German is the legally operative text (this is the notarized Handelsregister
 * filing, HRB 48120). Do not paraphrase or "fix" wording here; any change must
 * come from an amended, re-notarized contract.
 */
export default function GesellschaftsvertragDe() {
  return (
    <div className="tl-card-light tl-simple-card" style={{ display: "flex", flexDirection: "column", gap: "28px" }}>
      <p style={{ ...bodyStyle, fontFamily: "var(--font-serif)", fontSize: "16px" }}>
        der Tales&amp;Legends gemeinnützige UG (haftungsbeschränkt)
      </p>

      <Section title="§ 1 Firma, Sitz">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Die Firma der Gesellschaft lautet: Tales&amp;Legends gemeinnützige UG (haftungsbeschränkt).
          </li>
          <li style={bodyStyle}>Die Gesellschaft hat ihren Satzungssitz in Freital.</li>
        </ul>
      </Section>

      <Section title="§ 2 Zweck und Gegenstand des Unternehmens">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Die Gesellschaft verfolgt ausschließlich und unmittelbar gemeinnützige Zwecke im Sinne des Abschnitts
            „Steuerbegünstigte Zwecke" der Abgabenordnung.
          </li>
          <li style={bodyStyle}>
            Zweck der Gesellschaft ist die Förderung gemeinnütziger Zwecke im Sinne der §§ 52 ff. Abgabenordnung.
          </li>
        </ul>
        <p style={bodyStyle}>Die Gesellschaft verfolgt insbesondere folgende Zwecke:</p>
        <ul style={listStyle}>
          <li style={bodyStyle}>
            die Förderung von Kunst und Kultur (§ 52 Abs. 2 Nr. 5 AO), insbesondere durch die Planung, Organisation
            und Durchführung von kulturellen Veranstaltungen, Theateraufführungen sowie interaktiven und
            darstellenden Formaten, einschließlich Live Action Role Playing (LARP) als Form der darstellenden Kunst,
            sowie die Ermöglichung der Teilhabe an solchen Veranstaltungen,
          </li>
          <li style={bodyStyle}>
            die Förderung der Jugend- und Altenhilfe (§ 52 Abs. 2 Nr. 4 AO), insbesondere durch die Durchführung von
            kulturellen Veranstaltungen, Projekten und Bildungsangeboten für Kinder und Jugendliche zur Förderung von
            Kreativität, sozialem Verhalten, Teamfähigkeit und Persönlichkeitsentwicklung. Auch durch kulturelle und
            gemeinschaftsfördernde Angebote zur Stärkung der sozialen Teilhabe älterer Menschen sowie durch
            generationenübergreifende Projekte,
          </li>
          <li style={bodyStyle}>
            die Förderung des bürgerschaftlichen Engagements zugunsten gemeinnütziger Zwecke (§ 52 Abs. 2 Nr. 25 AO),
            insbesondere durch die Einbindung von Ehrenamtlichen in kulturelle und soziale Projekte.
          </li>
        </ul>
        <p style={bodyStyle}>
          Die Satzungszwecke werden insbesondere verwirklicht durch die Planung, Organisation und Durchführung von
          Veranstaltungen, Projekten, Workshops und Bildungsangeboten sowie durch die Entwicklung und Umsetzung
          kultureller, darstellender und interaktiver Formate.
        </p>
        <p style={bodyStyle}>
          Hierzu zählen insbesondere Formen des szenischen Spiels, der theaterpädagogischen Arbeit sowie interaktive
          Erzählformate wie Live Action Role Playing (LARP), einschließlich der kreativen Ausarbeitung von Rollen,
          Geschichten, Spielumgebungen und Requisiten.
        </p>
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Die Gesellschaft verpflichtet sich, alle ihr zur Verfügung stehenden Mittel an gemeinnützige oder
            mildtätige Projekte nachvollziehbar und transparent weiterzuleiten.
          </li>
          <li style={bodyStyle}>
            Gegenstand ist auch der Betrieb aller Geschäfte, die geeignet sind, den vorgenannten Gesellschaftszweck zu
            fördern. Die Gesellschaft ist berechtigt, Unternehmen im In- und Ausland zu erwerben, zu gründen oder
            sich daran zu beteiligen.
          </li>
          <li style={bodyStyle}>Die Gesellschaft ist selbstlos tätig und verfolgt nicht in erster Linie wirtschaftliche Zwecke.</li>
          <li style={bodyStyle}>
            Die Mittel der Gesellschaft dürfen nur für die satzungsmäßigen Zwecke verwendet werden. Die Gesellschafter
            dürfen keine Gewinnanteile und in ihrer Eigenschaft als Gesellschafter auch keine sonstigen Zuwendungen aus
            Mitteln der Gesellschaft erhalten.
          </li>
          <li style={bodyStyle}>
            Keine Person darf durch Ausgaben, die dem Zweck der Gesellschaft fremd sind, oder durch unverhältnismäßig
            hohe Vergütungen begünstigt werden.
          </li>
          <li style={bodyStyle}>
            Beschlüsse über die Änderung des Gesellschaftszwecks und des Unternehmensgegenstandes dürfen nur dann
            erfolgen, wenn die Änderungen die Steuerbegünstigung nach vorheriger Abstimmung mit der zuständigen
            Behörde nicht berühren.
          </li>
        </ul>
      </Section>

      <Section title="§ 3 Stammkapital">
        <ul style={listStyle}>
          <li style={bodyStyle}>Das Stammkapital der Gesellschaft beträgt EUR 500,00 (in Worten: Euro fünfhundert).</li>
          <li style={bodyStyle}>
            Auf das Stammkapital übernimmt als Geschäftsanteil: BrainEntertainments Holding UG (haftungsbeschränkt)
            den Geschäftsanteil lfd. Nr. 1 zu einem Nennbetrag von 500,00 Euro.
          </li>
          <li style={bodyStyle}>Die Einlage ist vor Anmeldung der Gesellschaft zum Handelsregister in voller Höhe einzuzahlen.</li>
        </ul>
      </Section>

      <Section title="§ 4 Vertretung">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Sind mehrere Geschäftsführer bestellt, so wird die Gesellschaft durch zwei Geschäftsführer oder durch
            einen Geschäftsführer in Gemeinschaft mit einem Prokuristen vertreten. Ist nur ein Geschäftsführer
            bestellt, so vertritt dieser die Gesellschaft allein. Einzelvertretungsbefugnis und die Befugnis, die
            Gesellschaft bei Vornahme von Rechtsgeschäften mit sich selbst oder als Vertreter eines Dritten
            uneingeschränkt zu vertreten, kann erteilt werden. Dies gilt auch, wenn sich alle Geschäftsanteile in
            einer Hand vereinigen.
          </li>
          <li style={bodyStyle}>Alle Bestimmungen dieser Satzung für Geschäftsführer gelten in gleicher Weise auch für Liquidatoren.</li>
        </ul>
      </Section>

      <Section title="§ 5 Beirat">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Die Gesellschaft kann einen Beirat gründen. Der Beirat ist kein Aufsichtsrat gemäß § 52 GmbHG. Für ihn
            gelten weder die Bestimmungen des § 52 GmbHG noch die des Aktienrechts. Die Haftung der Mitglieder des
            Beirats wird auf die Haftung für die Sorgfalt, die sie in eigenen Angelegenheiten anzuwenden pflegen
            (§ 708 BGB), beschränkt.
          </li>
          <li style={bodyStyle}>
            Der Beirat besteht aus (mindestens) zwei bis (maximal) acht Mitgliedern. Die Mitglieder werden durch die
            Gesellschafterversammlung mit einfacher Mehrheit bestellt und abberufen. Der Beirat wählt einen
            Vorsitzenden und einen stellvertretenden Vorsitzenden aus sich selbst.
          </li>
          <li style={bodyStyle}>
            Solange der Beirat nicht ordnungsgemäß besetzt ist, werden dessen Aufgaben von der Gesellschafterversammlung
            wahrgenommen.
          </li>
          <li style={bodyStyle}>
            Pro Themenfeld, in welchem die Gesellschaft Mittel gemäß § 2 Absatz 2 verwenden möchte, soll ein Experte
            als Beiratsmitglied bestellt werden.
          </li>
          <li style={bodyStyle}>Der Beirat kann sich eine Geschäftsordnung geben.</li>
        </ul>
      </Section>

      <Section title="§ 6 Gesellschafterversammlungen">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Gesellschafterversammlungen werden durch die Geschäftsführer einberufen, wobei jeder Geschäftsführer
            einzeln einberufungsberechtigt ist.
          </li>
          <li style={bodyStyle}>
            Aus wichtigem Grund kann jeder Gesellschafter jederzeit die Einberufung einer außerordentlichen
            Gesellschafterversammlung verlangen. Wenn der/die Geschäftsführer dem Verlangen nicht in angemessener
            Frist nachkommen, ist jeder Gesellschafter selbst berechtigt, die außerordentliche
            Gesellschafterversammlung einzuberufen.
          </li>
          <li style={bodyStyle}>
            Die Einberufung ist schriftlich, faxschriftlich oder per E-Mail an jeden Gesellschafter unter Angabe von
            Ort, Tag, Zeit und Tagesordnung mit einer Frist von mindestens zehn (10) Werktagen zu richten; bei
            Eilbedürftigkeit kann die Einberufung mit angemessener kürzerer Frist erfolgen.
          </li>
          <li style={bodyStyle}>
            Der Lauf der Frist beginnt mit dem der Aufgabe zur Post bzw. der Versendung (im Falle von Telefax und
            E-Mail-Einladungen) folgenden Tag. Der Tag der Versammlung wird bei Berechnung der Frist nicht mitgezählt.
          </li>
          <li style={bodyStyle}>
            Die Gesellschafterversammlung ist beschlussfähig, wenn sämtliche Gesellschafter anwesend bzw. vertreten
            sind. Ist das nicht der Fall, so muss unverzüglich eine neue Gesellschafterversammlung mit gleicher
            Tagesordnung einberufen werden, die dann ohne Rücksicht auf das vertretene Stammkapital beschließen kann.
            Darauf ist in der Einladung hinzuweisen.
          </li>
          <li style={bodyStyle}>
            Sind sämtliche Gesellschafter anwesend oder vertreten und mit der Beschlussfassung einverstanden, so
            können Beschlüsse auch dann gefasst werden, wenn die für die Einberufung und Ankündigungen geltenden
            gesetzlichen oder gesellschaftsvertraglichen Vorschriften nicht eingehalten worden sind.
          </li>
          <li style={bodyStyle}>
            Jeder Gesellschafter kann sich in der Gesellschafterversammlung durch einen mit schriftlicher Vollmacht
            ausgestatteten Bevollmächtigten vertreten lassen.
          </li>
        </ul>
      </Section>

      <Section title="§ 7 Gesellschafterbeschlüsse">
        <ul style={listStyle}>
          <li style={bodyStyle}>Die Beschlüsse der Gesellschafter werden in Gesellschafterversammlungen gefasst.</li>
          <li style={bodyStyle}>
            Beschlüsse der Gesellschafter können jederzeit ohne förmliche Gesellschafterversammlung gefasst werden,
            sofern sämtliche Gesellschafter an der Beschlussfassung teilnehmen und nicht zwingende gesetzliche
            Vorschriften eine andere Form vorschreiben. Die Beschlussfassung kann entweder schriftlich im
            Umlaufverfahren oder per Telefax, E-Mail, Chat oder Videokonferenz erfolgen. Soweit über die
            Gesellschafterbeschlüsse nicht eine notarielle Niederschrift aufgenommen wird oder der
            Gesellschafterbeschluss schriftlich im Umlaufverfahren gefasst wird, ist über jeden gefassten
            Gesellschafterbeschluss (zu Beweiszwecken, nicht als Wirksamkeitsvoraussetzung) eine Niederschrift
            anzufertigen.
          </li>
          <li style={bodyStyle}>
            Je EUR 1,-- eines Geschäftsanteils gewährt eine Stimme. Gesellschafterbeschlüsse werden mit der einfachen
            Mehrheit der abgegebenen Stimmen gefasst, soweit nicht das Gesetz oder dieser Gesellschaftsvertrag
            zwingend eine andere Mehrheit vorsehen.
          </li>
        </ul>
      </Section>

      <Section title="§ 8 Geschäftsjahr">
        <p style={bodyStyle}>
          Das Geschäftsjahr ist das Kalenderjahr. Das erste Geschäftsjahr beginnt mit der Eintragung der Gesellschaft
          in das Handelsregister und endet mit dem darauffolgenden 31. Dezember.
        </p>
      </Section>

      <Section title="§ 9 Jahresabschluss und Ergebnisverwendung">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Für die Aufstellung und Prüfung des Jahresabschlusses und falls erforderlich des Lageberichts gelten die
            gesetzlichen Vorschriften.
          </li>
          <li style={bodyStyle}>
            Die Gesellschafter erhalten keine Gewinnanteile und in ihrer Eigenschaft als Gesellschafter auch keine
            sonstigen Zuwendungen aus Mitteln der Gesellschaft.
          </li>
          <li style={bodyStyle}>
            Die Gesellschaft kann nur insoweit Rücklagen bilden und/oder Mittel ansammeln, als dies für eine
            gemeinnützige Körperschaft rechtlich und steuerlich zulässig ist.
          </li>
        </ul>
      </Section>

      <Section title="§ 10 Dauer">
        <p style={bodyStyle}>Die Gesellschaft ist auf unbestimmte Zeit abgeschlossen.</p>
      </Section>

      <Section title="§ 11 Auflösung, Zweckfortfall">
        <ul style={listStyle}>
          <li style={bodyStyle}>
            Bei Auflösung der Körperschaft oder bei Wegfall steuerbegünstigter Zwecke der Gesellschaft fällt das
            Vermögen, soweit es die eingezahlten Kapitalanteile der Gesellschafter und den gemeinen Wert der von den
            Gesellschaftern geleisteten Sacheinlagen übersteigt, an eine juristische Person des öffentlichen Rechts
            oder eine andere steuerbegünstigte Körperschaft zwecks Verwendung für die Förderung von Kunst und Kultur.
          </li>
          <li style={bodyStyle}>
            Beschlüsse über die künftige Verwendung des Vermögens dürfen erst nach Einwilligung des zuständigen
            Finanzamts ausgeführt werden.
          </li>
        </ul>
      </Section>

      <Section title="§ 12 Schlussbestimmungen">
        <ul style={listStyle}>
          <li style={bodyStyle}>Die Bekanntmachungen der Gesellschaft erfolgen nur im Bundesanzeiger.</li>
          <li style={bodyStyle}>
            Die mit der Gründung der Gesellschaft verbundenen Kosten (Steuerberater-, Notar-, Gerichts- und ggf.
            Anwaltskosten, sowie Kosten und Gebühren bei Behörden) bis zum Betrag von 300,00 Euro trägt die
            Gesellschaft. Darüberhinausgehende Kosten tragen die Gesellschafter im Verhältnis der Nennbeträge ihrer
            Geschäftsanteile.
          </li>
          <li style={bodyStyle}>
            Durch die Unwirksamkeit einzelner Bestimmungen dieses Vertrages wird die Wirksamkeit der übrigen
            Bestimmungen nicht berührt.
          </li>
          <li style={bodyStyle}>Als Gerichtsstand wird Freital vereinbart.</li>
        </ul>
      </Section>
    </div>
  );
}
